import {
  nextTick,
  ref,
  toValue,
  type MaybeRefOrGetter,
  type TemplateRef,
} from "vue";

export function useEditing(
  content: MaybeRefOrGetter<string>,
  onSave: (content: string) => void,
  editTextarea: TemplateRef<HTMLTextAreaElement>,
) {
  const isEditing = ref(false);
  const draft = ref("");

  const startEditing = async () => {
    draft.value = toValue(content);
    isEditing.value = true;
    await nextTick();
    editTextarea.value?.focus();
  };

  const cancelEditing = () => {
    isEditing.value = false;
    draft.value = "";
  };

  const saveEditing = () => {
    if (draft.value.trim()) {
      onSave(draft.value);
      isEditing.value = false;
      draft.value = "";
    }
  };

  return { isEditing, draft, startEditing, cancelEditing, saveEditing };
}
